import xss from "xss";

const SEARCH_PARAM_KEY = "productQuery";

export function getSearchParam() {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(SEARCH_PARAM_KEY) || "";
  return xss(value);
}

export function clearSearchParam(removeParam = false) {
  const params = new URLSearchParams(window.location.search);
  const searchQuery = params.get(SEARCH_PARAM_KEY);
  if (searchQuery) {
    params.delete(SEARCH_PARAM_KEY);
    if (removeParam) {
      updateBrowserHistory(params, false);
    }
  }
}

export function setSearchParam(value, useReplaceState = false) {
  const params = new URLSearchParams(window.location.search);
  params.set(SEARCH_PARAM_KEY, value);
  updateBrowserHistory(params, useReplaceState);
}

function updateBrowserHistory(params, useReplaceState) {
  const paramString = params.toString();
  const newUrl = `${window.location.pathname}${
    paramString ? "?" + paramString : ""
  }${window.location.hash}`;
  if (useReplaceState) {
    window.history.replaceState({}, null, newUrl);
  } else {
    window.history.pushState({}, null, newUrl);
  }
}
